@if (type === 'dropdown') {
  <manager-wrapper-dropdown [type]="type" [wrapper]="wrapper" [dropdown]="dropdown"></manager-wrapper-dropdown>
}
@if (type === 'modal') {
  <manager-wrapper-modal [type]="type" [wrapper]="wrapper" [action]="action" [file]="file"></manager-wrapper-modal>
}
@if (type === 'offcanvas') {
  <manager-wrapper-offcanvas [type]="type" [wrapper]="wrapper" [action]="action"></manager-wrapper-offcanvas>
}
@if (type === 'page') {
  <manager-wrapper-page [type]="type" [wrapper]="wrapper"></manager-wrapper-page>
}
